import React from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "lucide-react";
interface Crumb {
  label: string;
  to?: string;
}
export function Breadcrumbs({
  items
}: {
  items: Crumb[];
}) {
  return <nav aria-label="Kruimelpad" data-id="element-25" data-mp="2r43675oifc58">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-muted" data-id="element-26" data-mp="2r78uiipbe9zw">
        {items.map((c, i) => <li key={c.label} className="flex items-center gap-1.5" data-id="element-27" data-mp="2m8e52xwudn6t" data-mpi={i}>
            {c.to ? <Link to={c.to} className="transition-colors duration-150 hover:text-ink" data-id="element-28" data-mp="1yijtsks686oo">
                {c.label}
              </Link> : <span aria-current="page" className="text-ink" data-id="element-29" data-mp="28foeeg6dbu3d">
                {c.label}
              </span>}
            {i < items.length - 1 && <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-30" data-mp="23hwpzw4xmq3x" />}
          </li>)}
      </ol>
    </nav>;
}